<template>
  <div>
    <div class="centro">
      <div v-if="entesFederativos.length > 0" class="layout-container">
        <div class="mapa-container">
          <img src="@/assets/images/mapa-brasil.png" alt="Mapa do Brasil com destaque para Goiás" class="mapa-brasil">
        </div>
        <div class="lista-cidades">
          <h2>CIDADES ENCONTRADAS EM GOIÁS</h2>

          <div class="lista-alfabeto">
            <span v-for="letter in alphabet" :key="letter" @click="filterByLetter(letter)" :class="{ ativo: activeLetter === letter }">
              {{ letter }}
            </span>
          </div>

          <ul>
            <li v-for="ente in filteredEnteFederativos" :key="ente.id" @click="selectCity(ente)" :class="{ ativo: activeCityId === ente.id }">
              <router-link :to="{ name: 'LegislacaoPorEnteFederativoBySlug', params: { slug: ente.slug } }">
                {{ ente.nome }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="entesFederativos.length === 0">
        <p>Nenhum ente federativo encontrado para aparecer no Legisla.</p>
      </div>
      <div v-else>
        <p>Carregando cidades encontradas em Goiás...</p>
      </div>
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";

export default {
  name: "PesquisaLegislacaoMunicipal",
  data() {
    return {
      entesFederativos: [],
      legislacaoMunicipalApi: null,
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      activeLetter: null,
      activeCityId: null,
    };
  },
  computed: {
    filteredEnteFederativos() {
      if (!this.activeLetter) {
        return this.entesFederativos;
      }
      return this.entesFederativos.filter(ente => 
        ente.nome.toUpperCase().startsWith(this.activeLetter)
      );
    }
  },
  methods: {
    filterByLetter(letter) {
      if (this.activeLetter === letter) {
        this.activeLetter = null;
      } else {
        this.activeLetter = letter;
      }
      this.activeCityId = null;
    },
    selectCity(ente) {
      this.activeCityId = ente.id;
    }
  },
  created() {
    this.legislacaoMunicipalApi = new LegislacaoMunicipalApi();
  },
  async mounted() {
    try {
      const allEntesFederativos = await this.legislacaoMunicipalApi.getEntesFederativos();
      this.entesFederativos = allEntesFederativos
        .filter(ente => ente.id !== 1)
        .sort((a, b) => a.nome.localeCompare(b.nome));
    } catch (error) {
      console.error("Erro ao carregar cidades encontradas em Goiás:", error);
      this.entesFederativos = [];
    }
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: #2c3f2b;
  padding-left: 0.5rem;
  border-left: #ffa900 solid 0.15rem;
  margin: 2.5rem 0rem 1.5rem 1rem;
  
}

.lista-cidades h2 {
  font-family: "Poppins-Bold", sans-serif;
  text-align: center;
  font-size: 16.9px;
  color: #0E489F;
  margin-top: 4rem;
}
.layout-container {
  display: flex;
  align-items: flex-start;
}

.mapa-container {
  margin-right: 0px;
  margin-left: -50px;
}

.mapa-brasil {
  max-width: 700px;
  height: auto;
  position: relative;
  top: -25px;
}

.lista-alfabeto {
  margin-bottom: 1rem;
  display: flex;  
  flex-wrap: wrap; 
  width: fit-content;
}

.lista-alfabeto span {
  font-family: 'Anton';
  font-size: 27.8px;
  color: grey;
  cursor: pointer;
  // width: 1.1rem;          /* largura fixa do “quadro” */
  height: 1.1rem;         /* altura fixa do “quadro” */
  display: flex;          /* centralização */
  align-items: center;    /* centraliza verticalmente */
  justify-content: center;/* centraliza horizontalmente */
  padding: 0.4rem 0.3rem;
  transition: all 0.3s ease;
  border-radius: 4px;
  font-weight: bold;
}

.lista-alfabeto span.ativo {
  background-color: #ffb24f;
  color: #083e07;
  font-weight: bold;
}

.lista-alfabeto span:hover {
  background-color: #ffb24e;
  color: #083e07;
  padding: 0.3rem;
}

.lista-cidades ul {
  list-style: none;
  padding: 0;
  width: fit-content;
  margin: 0;
  margin-left: 50px;
}

.lista-cidades li {
  padding: 0.5rem;
  color: #928989;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
  margin-bottom: 0.2rem;
  text-align: center;
  font-size: 18.9px !important
}

.lista-cidades li:hover,
.lista-cidades li.ativo {
  background-color: #ffb24e;
}

.lista-cidades li:hover a {
    color: #083e07;
    font-weight: bold;
    font-size: 18.9px !important;
    
}

.lista-cidades li.ativo a {
    color: black;
}

.lista-cidades li a {
    text-decoration: none;
    color: inherit; 
    display: block;

}

@media (max-width: 768px) {
  .layout-container {
    flex-direction: column-reverse;
    align-items: center;
  }

  .mapa-container {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .mapa-brasil {
    max-width: 100%;
    top: 0;
    padding-left: 1rem;
  }

  .lista-cidades ul {
    margin-left: 0;
    width: 100%;
  }

  .lista-cidades li {
    padding: 0.4rem;
    font-size: 0.9em;
  }

  .lista-alfabeto {
    width: 100%;
    text-align: center;
    padding: 0 0.5rem;
  }
}

@media (min-width: 769px) and (max-width: 1023px) {
  .layout-container {
    flex-direction: row;
    align-items: flex-start;
  }

  .mapa-container {
    margin-right: 15px;
    max-width: 50%; /* Adjust map size for this range */
  }

  .mapa-brasil {
    max-width: 100%;
    height: auto;
    top: -15px; /* Slightly adjust map position */
  }

  .lista-cidades ul {
    margin-left: 20px;
    width: auto; /* Allow list to take natural width */
  }

  .lista-cidades li {
    padding: 0.45rem;
    font-size: 0.95em;
  }

  .lista-alfabeto {
    width: auto;
  }
}
</style>
